
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/music-quiz",
      function () {
        return require("private-next-pages/features/music-quiz.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/music-quiz"])
      });
    }
  